import { UtmParams } from "@Types/url";

const stringifyUrlValues = (utmParams: UtmParams) => {
  const campaign = utmParams.utm_campaign ? `~campaign=${utmParams.utm_campaign}` : "";
  const channel = utmParams.utm_source ? `~channel=${utmParams.utm_source}` : "";
  const tags = utmParams.utm_medium ? `~tags=${utmParams.utm_medium}` : "";

  return `${campaign}${getSeparator(campaign && (channel || tags), false)}${channel}${getSeparator(
    (campaign || channel) && tags,
    false
  )}${tags}`;
};

const queryCheck = (query: string) => {
  const sourceRegex = new RegExp("utm_source", "g");
  const mediumRegex = new RegExp("utm_medium", "g");
  const campaignRegex = new RegExp("utm_campaign", "g");

  return (
    query.search(sourceRegex) > -1 ||
    query.search(mediumRegex) > -1 ||
    query.search(campaignRegex) > -1
  );
};

const getUtmParams = (query: string) => {
  const paramsList = query ? query.substring(1).split("&") : [];

  return paramsList.reduce((acc, curr) => {
    const key = curr.split("=")[0];
    const value = curr.split("=")[1];
    return { ...acc, [key]: value };
  }, {} as UtmParams);
};

const getSeparator = (query: string, first: boolean) => {
  return query !== "" ? (first ? "?" : "&") : "";
};

const getUrlAppStoreButton = (store?: string): string => {
  let cookieQuery = "";

  if (queryCheck(window.location.search)) {
    sessionStorage.removeItem("appStoreButtonHref");
    sessionStorage.setItem(
      "appStoreButtonHref",
      stringifyUrlValues(getUtmParams(window.location.search))
    );
    cookieQuery = sessionStorage.getItem("appStoreButtonHref") || "";
  } else if (sessionStorage.getItem("appStoreButtonHref")) {
    cookieQuery = sessionStorage.getItem("appStoreButtonHref") || "";
  }

  if (store === "google") {
    const googleStoreUrl = encodeURIComponent(
      "https://play.google.com/store/apps/details?id=com.printklub.polabox"
    );
    cookieQuery += `&$desktop_url=${googleStoreUrl}`;
  }

  const finalQuery =
    window.location.pathname !== "/"
      ? `$deeplink_path=${window.location.pathname}${getSeparator(
          cookieQuery,
          false
        )}${cookieQuery}`
      : `${cookieQuery}`;

  if (process.env.REACT_APP_CHEERZ_ONELINK) {
    return `${process.env.REACT_APP_CHEERZ_ONELINK}/sitemobile${getSeparator(
      finalQuery,
      true
    )}${finalQuery}`;
  } else return "#";
};

export default getUrlAppStoreButton;
